import React, { useContext, useEffect, useState, useRef } from 'react';
import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png";
import PanInput from "../../../components/OtpInput/PanInput";
import { FormWrapper } from "../../../components/loan/style";
import Button from "../../../components/ui/Button";
import Alert from "../../../components/ui/Alert";
import { verifyPan } from "../../../Utils/api";
import { useNavigate } from "react-router-dom";
import Input from "../../../components/ui/Input";
import { getStorage, goBack, setStorage, isEmpty } from "../../../Utils/common";
import { regexPan } from "../../../Utils/formValidation";
import ContextDashboard from "../../../Context/ContextDashboard";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";

const initialData = {
  monthlyIncome: "",
};

function PanDetails() {
  const [pan, setPan] = useState(["", "", "", "", "", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({});
  const [showSteps, setShowSteps] = useState(-1);
  const [toggle, setToggle] = useState(true);
  const [progressBar, setProgressBar] = useState(getStorage("step_percent"));
  const { setps } = useContext(ContextDashboard);
  const inputRefs = useRef([]);
  const [formData, setFormData] = useState(initialData);
  const [formDataError, setFormDataError] = useState(initialData);

  const navigate = useNavigate();
  const { message, setMessage, logout, handleEvent } = useContext(ContextDashboard);

  const submit = () => {
    let panData = pan?.join("").toUpperCase();

    if (!regexPan.test(panData)) {
      setMessage({ type: 'error', msg: "Please enter a valid PAN number" });
      return;
    }

    if (!formData.monthlyIncome) {
      setFormDataError({ ...formDataError, monthlyIncome: "Monthly income is required" });
      return;
    }

    const param = {
      event_name: "pancard_verification",
      pancard: panData,
      profile_id: getStorage("cust_profile_id") || "",
      monthly_income: formData.monthlyIncome,
    };

    setLoading(true);
    verifyPan(param).then(resp => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setStorage("pancard", panData);
        setStorage("fullName", resp?.data?.Data?.full_name);
        setStorage("step_percent", resp?.data?.Data?.step_percentage);
        setStorage("next_step", resp?.data?.Data?.next_step);
        setResponse(resp?.data);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });
        handleEvent(getStorage("next_step"));
      } else if (resp?.data?.Status === 4) {
        logout();
      } else {
        setPan(["", "", "", "", "", "", "", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        setMessage({ type: "error", msg: resp?.data?.Message });
      }
    });
  };

  const showSteps_ = () => {
    setToggle(!toggle);
  };

  useEffect(() => {
    if (!isEmpty(setps)) {
      checkStep(setps);
    }
  }, [setps]);

  function checkStep(data) {
    setProgressBar(data?.step_complete_percent);
    const steps = data?.step_stage - 1;
    if (data?.step_complete_percent === 100) {
      setToggle(false);
    }
    setShowSteps(steps);
  }

  const onChange = (e) => {
    let { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormDataError({ ...formDataError, [name]: "" });
  };

  const handleIncomeChange = (e) => {
    const { value } = e.target;

    if (/^\d{0,7}$/.test(value)) {
      setFormData({ ...formData, monthlyIncome: value });
      setFormDataError({ ...formDataError, monthlyIncome: "" });
    }
  };

  return (
    <>
      <ProgressBar value={`${progressBar}%`}>
        <div></div>
        <></>
      </ProgressBar>
      <br />

      <BoxWrapper className="min-h-screen">

        <div className="max-w-4xl mx-auto">

          {/* Back Button */}
          <div
            onClick={() => goBack(navigate, "/my-dashboard/")}
            className="inline-flex items-center gap-2 mb-6 px-5 py-3 border rounded-xl cursor-pointer bg-white hover:bg-gray-50 transition shadow-sm"
          >
            <img
              src={arrowIcon}
              alt="Back"
              className="w-4 transition-transform group-hover:-translate-x-1"
            />
            <span className="font-medium">Back</span>
          </div>

          {/* Card */}
          <div className="bg-white rounded-3xl shadow-xl p-5 sm:p-8 md:p-10">

            {/* Header */}
            <div className="text-center mb-8">

              <div className="w-16 h-16 mx-auto rounded-2xl bg-blue-50 flex items-center justify-center mb-5">

                <svg
                  className="w-8 h-8 text-[#2D5F7A]"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path d="M9 12l2 2 4-4" />
                  <path d="M21 12c0 1.66-.67 3.16-1.76 4.24A6 6 0 0112 21a6 6 0 01-7.24-4.76A6 6 0 0112 3a6 6 0 019 9z" />
                </svg>

              </div>

              <h2 className="text-2xl sm:text-3xl font-bold text-[#1D3557]">
                PAN Authentication
                <span className="text-red-500 ml-1">*</span>
              </h2>

              <p className="mt-3 text-gray-500 text-sm sm:text-base">
                Please enter your PAN card number and monthly income.
                Your information is encrypted and secure.
              </p>

            </div>

            <FormWrapper>

              <Alert
                setMessage={setMessage}
                message={message}
              />

              <div className="space-y-8">

                <div>

                  <label className="block text-sm font-semibold text-[#1D3557] mb-3">
                    PAN Card Number
                  </label>

                  <PanInput
                    type="text"
                    setOtp={setPan}
                    otp={pan}
                    isDisable={false}
                    placeholder="*"
                    number={false}
                    inputRefs={inputRefs}
                  />

                </div>

                <div>

                  <Input
                    label="Monthly Income *"
                    name="monthlyIncome"
                    error={formDataError?.monthlyIncome}
                    onChange={handleIncomeChange}
                    value={formData?.monthlyIncome}
                    required={true}
                    type="number"
                  />

                </div>

              </div>

              {/* Security Box */}

              <div className="mt-8 flex gap-4 rounded-2xl border border-green-200 bg-green-50 p-5">

                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow shrink-0">
                  🔒
                </div>

                <div>

                  <h4 className="font-semibold text-[#1D3557]">
                    Your information is safe with us
                  </h4>

                  <p className="text-sm text-gray-600 mt-1">
                    We use bank-grade encryption to securely process your PAN and income details.
                  </p>

                </div>

              </div>

              {/* Button */}

              <div className="mt-8">
                <Button
                  className="w-full bg-[#2D5F7A]"
                  title="Continue"
                  onClick={submit}
                  loading={loading}
                />
              </div>

              {/* Footer */}

              <div className="flex justify-center items-center gap-2 mt-5 text-sm text-gray-500">
                🔒
                <span>Your data is secure and encrypted</span>
              </div>

            </FormWrapper>

          </div>

        </div>

      </BoxWrapper>
    </>
  );
}

export default PanDetails;